import { Component, Input, OnInit } from "@angular/core";
import { LoaderService } from "./loader.service";

@Component({
  selector: 'app-progress-spinner',
  template: `<ng-container *ngIf="!overlay; else progressSpinner">
      <div class="overlay">
        <div class="center">
          <ng-template [ngTemplateOutlet]="progressSpinner"></ng-template>
        </div>
      </div>
    </ng-container>
    <ng-template #progressSpinner>
      <mat-progress-spinner
        [diameter]="diameter"
        [mode]="mode"
        [color]="color"
        [strokeWidth]="strokeWidth"
        [value]="value"
      >
      </mat-progress-spinner>
    </ng-template>`,
  styleUrls: ['progress-spinner.component.scss'],
})
export class ProgressSpinnerComponent implements OnInit {
  @Input() value: number = 100;
  @Input() diameter: number = 70;
  @Input() mode: string = 'indeterminate';
  @Input() strokeWidth: number = 10;
  @Input() overlay: boolean = false;
  @Input() color: string = 'primary';

  constructor(private loaderService: LoaderService) {
    this.loaderService.isLoading.subscribe((v) => {
      console.log(v);
      this.overlay = v;
    });
  }

  ngOnInit(): void {}
}